export enum Brand {
  SKRILL = 'skrill',
  NETELLER = 'neteller',
  SKRILL_AND_NETELLER = 'skrill_and_neteller',
  PAYSAFECARD = 'paysafecard'
}
